<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <mat-icon>trending_up</mat-icon>
            <div>
                Úprava příjmu
                @if (type.value) {
                    <span class="hidden md:inline"> ({{ type.value | option: ('incomeType' | listByType) }}) </span>
                }
            </div>
        </div>

        <button mat-dialog-close type="button" [attr.data-testid]="'income-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form [formGroup]="incomeDialogForm" [attr.data-testid]="'income-dialog'" class="hypo-dialog-content">
        <div appHasError #hasError="appHasError">
            <div class="flex flex-col">
                <div class="flex flex-col lg:flex-row gap-4">
                    <div class="basics w-full flex flex-col">
                        <h4>Základní údaje</h4>
                        <div>
                            <app-hypo-radio
                                [label]="'Typ příjmu'"
                                [listName]="'incomeType'"
                                [toggleAbleOptions]="true"
                                [itemClass]="'max-md:w-full'"
                                formControlName="type">
                            </app-hypo-radio>
                        </div>
                        @if ('professionType' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                            <div>
                                <app-hypo-radio
                                    [label]="'Typ profese'"
                                    [listName]="'profession'"
                                    [toggleAbleOptions]="true"
                                    formControlName="professionType">
                                </app-hypo-radio>
                            </div>
                        }
                        @if ('contractTermPeriod' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                            <div>
                                <app-hypo-radio
                                    [label]="'Smlouva na dobu'"
                                    [showingList]="[
                                        { label: 'určitou', value: ContractTermPeriod.fixedTerm },
                                        { label: 'neurčitou', value: ContractTermPeriod.indefinite },
                                    ]"
                                    formControlName="contractTermPeriod">
                                </app-hypo-radio>
                            </div>
                        }

                        @if ('amount' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                            <div class="flex flex-row items-center">
                                <app-hypo-input
                                    class="flex w-full xs:w-1/2"
                                    [inputmode]="'decimal'"
                                    [label]="'amount' | textByType: incomeConfig.nameOnTypes : type.value"
                                    [mask]="'separator.0'"
                                    [step]="1000"
                                    [suffix]="'Kč'"
                                    [tooltip]="'amount' | textByType: incomeConfig.tooltipOnTypes : type.value"
                                    formControlName="amount">
                                </app-hypo-input>
                            </div>
                        }

                        @if ('shareInTheCompany' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                            <div>
                                <app-hypo-input
                                    class="flex w-full md:w-1/2"
                                    [dropSpecialCharacters]="false"
                                    [inputmode]="'decimal'"
                                    [label]="'Podíl ve firmě'"
                                    [mask]="'0*.999'"
                                    [suffix]="'%'"
                                    formControlName="shareInTheCompany">
                                </app-hypo-input>
                            </div>
                        }
                        <div class="flex flex-col xs:flex-row xs:gap-4">
                            @if ('fromDate' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                <app-hypo-datepicker
                                    [conditionalRequired]="!isRequiredByType('fromDate')"
                                    [label]="'fromDate' | textByType: incomeConfig.nameOnTypes : type.value"
                                    formControlName="fromDate">
                                </app-hypo-datepicker>
                            }

                            @if (
                                'untilDate'
                                    | shouldShowInput
                                        : incomeConfig.showInputOnTypes
                                        : type.value
                                        : additionalIncomeTypeCondition
                            ) {
                                <app-hypo-datepicker
                                    [conditionalRequired]="!isRequiredByType('untilDate')"
                                    [label]="'Do data'"
                                    formControlName="untilDate">
                                </app-hypo-datepicker>
                            }
                        </div>

                        @if ('employmentExtendedCount' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                            <div>
                                <app-hypo-radio
                                    [label]="'Kolikrát byl poměr prodloužen?'"
                                    [showingList]="[
                                        { label: '0x', value: 0 },
                                        { label: '1x', value: 1 },
                                        { label: '2x', value: 2 },
                                        { label: '3 a vícekrát', value: 3 },
                                    ]"
                                    formControlName="employmentExtendedCount">
                                </app-hypo-radio>
                            </div>
                        }
                        <div>
                            <app-hypo-radio
                                [label]="'Příjmy pobírám'"
                                [listName]="'incomeLocation'"
                                formControlName="location">
                            </app-hypo-radio>
                        </div>
                        @if (
                            incomeDialogForm.get('location').value === IncomeLocationEnum.expat ||
                            incomeDialogForm.get('location').value === IncomeLocationEnum.pendler
                        ) {
                            <div>
                                <app-hypo-radio
                                    [label]="'Peníze chodí na účet'"
                                    [showingList]="[
                                        { value: 'CZE', label: 'český' },
                                        { value: 'other', label: 'zahraniční' },
                                    ]"
                                    formControlName="locationAccount">
                                </app-hypo-radio>
                            </div>
                        }
                        @if (
                            incomeDialogForm.get('location').value === IncomeLocationEnum.expat ||
                            incomeDialogForm.get('location').value === IncomeLocationEnum.pendler
                        ) {
                            <div class="flex flex-col xs:flex-row xs:gap-4">
                                <app-hypo-select
                                    [label]="'Z jaké země?'"
                                    [listName]="'country'"
                                    formControlName="locationCountry"
                                    class="w-full">
                                </app-hypo-select>
                                <app-hypo-select
                                    [label]="'Měna příjmu'"
                                    [listName]="'currency'"
                                    formControlName="currency"
                                    class="w-full">
                                </app-hypo-select>
                            </div>
                        }
                        <div class="flex flex-row items-center justify-start flex-wrap gap-4">
                            @if (
                                'stoppedInLastTwoYears' | shouldShowInput: incomeConfig.showInputOnTypes : type.value
                            ) {
                                <div class="toggle-multi-labels">
                                    <label>Podnikání přerušeno v posledních 2 letech</label>
                                    <div>
                                        <mat-label>Ne</mat-label>
                                        <mat-slide-toggle
                                            formControlName="stoppedInLastTwoYears"
                                            [attr.data-testid]="'stoppedInLastTwoYears'"
                                            >Ano
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                            }
                            @if ('employedAtOwnCompany' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                <div class="toggle-multi-labels">
                                    <label>Zaměstnán ve vlastní/rodinné firmě</label>
                                    <div>
                                        <mat-label>Ne</mat-label>
                                        <mat-slide-toggle
                                            formControlName="employedAtOwnCompany"
                                            [attr.data-testid]="'employedAtOwnCompany'">
                                            Ano
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                            }
                            <div class="toggle-multi-labels">
                                <label>Vyplácení na účet</label>
                                <div>
                                    <mat-label>Ne</mat-label>
                                    <mat-slide-toggle
                                        formControlName="isPaidToAccount"
                                        [attr.data-testid]="'isPaidToAccount'">
                                        Ano
                                    </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if (showMore) {
                        <div class="details flex flex-col w-full">
                            <h4>Podrobnosti</h4>
                            @if ('costAccounting' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                <div class="flex flex-col xs:flex-row xs:gap-4">
                                    <app-hypo-select
                                        [label]="'Nákladová evidence'"
                                        [listName]="'costAccounting'"
                                        [searchAble]="false"
                                        formControlName="costAccounting"
                                        class="w-full">
                                    </app-hypo-select>
                                    @if (incomeDialogForm.get('costAccounting').value === 'flatRate') {
                                        <app-hypo-select
                                            [label]="'Výše paušálu'"
                                            [listName]="'flatRate'"
                                            [searchAble]="false"
                                            formControlName="flatRate"
                                            class="w-full">
                                        </app-hypo-select>
                                    }
                                </div>
                            }
                            @if ('row101' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                <ng-container formGroupName="taxReturn">
                                    <app-hypo-input
                                        [inputmode]="'decimal'"
                                        [label]="'(101) Příjmy ze samostatné činnosti'"
                                        [mask]="'separator.0'"
                                        [suffix]="'Kč'"
                                        formControlName="row101">
                                    </app-hypo-input>
                                </ng-container>
                            }
                            <ng-container formGroupName="source">
                                <div class="flex flex-col xs:flex-row xs:gap-4">
                                    @if (
                                        'source.createdAt' | shouldShowInput: incomeConfig.showInputOnTypes : type.value
                                    ) {
                                        <app-hypo-datepicker
                                            [label]="'Firma podniká od'"
                                            formControlName="createdAt"
                                            class="w-full">
                                        </app-hypo-datepicker>
                                    }
                                </div>
                                <div class="flex flex-col xl:flex-row xl:gap-4">
                                    @if ('source.name' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                        <app-hypo-input
                                            [inputmode]="'text'"
                                            [label]="'source.name' | textByType: incomeConfig.nameOnTypes : type.value"
                                            formControlName="name"
                                            class="w-full">
                                        </app-hypo-input>
                                    }
                                    @if (
                                        'source.idNumber' | shouldShowInput: incomeConfig.showInputOnTypes : type.value
                                    ) {
                                        <app-hypo-input
                                            [inputmode]="'decimal'"
                                            [label]="
                                                'source.idNumber' | textByType: incomeConfig.nameOnTypes : type.value
                                            "
                                            [mask]="'00000000'"
                                            [patternErrorMessage]="'Musí být 8 čísel'"
                                            [suffixTemplate]="idNumberSuffixTemplate"
                                            [suffixFill]="false"
                                            [conditionalRequired]="!isRequiredByType('source.idNumber')"
                                            (keyup.enter)="findAres(incomeDialogForm.get('source.idNumber').value)"
                                            formControlName="idNumber"
                                            class="w-full">
                                            <ng-template #idNumberSuffixTemplate>
                                                <div
                                                    (click)="findAres(incomeDialogForm.get('source.idNumber').value)"
                                                    class="input-info input-action">
                                                    @if (!loaderService.loading()) {
                                                        <mat-icon>search</mat-icon>
                                                    } @else {
                                                        <mat-spinner diameter="20"></mat-spinner>
                                                    }
                                                </div>
                                            </ng-template>
                                        </app-hypo-input>
                                    }
                                </div>
                                @if ('source.naceCode' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                    <div class="flex flex-col">
                                        <app-hypo-select
                                            [dontPreload]="true"
                                            [label]="'Odvětví NACE'"
                                            [listName]="'nace'"
                                            formControlName="naceCode">
                                        </app-hypo-select>
                                    </div>
                                }
                            </ng-container>
                            <div class="flex flex-row flex-wrap items-center justify-start gap-4">
                                @if ('isTrialPeriod' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                    <div class="toggle-multi-labels">
                                        <label>Ve zkušební lhůtě</label>
                                        <div>
                                            <mat-label>Ne</mat-label>
                                            <mat-slide-toggle
                                                formControlName="isTrialPeriod"
                                                [attr.data-testid]="'isTrialPeriod'">
                                                Ano
                                            </mat-slide-toggle>
                                        </div>
                                    </div>
                                }
                                @if ('isNoticePeriod' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                    <div class="toggle-multi-labels">
                                        <label>Ve výpovědní lhůtě</label>
                                        <div>
                                            <mat-label>Ne</mat-label>
                                            <mat-slide-toggle
                                                formControlName="isNoticePeriod"
                                                [attr.data-testid]="'isNoticePeriod'">
                                                Ano
                                            </mat-slide-toggle>
                                        </div>
                                    </div>
                                }
                                @if ('isSubsequent' | shouldShowInput: incomeConfig.showInputOnTypes : type.value) {
                                    <div class="toggle-multi-labels">
                                        <label>Navazující smlouva</label>
                                        <div>
                                            <mat-label>Ne</mat-label>
                                            <mat-slide-toggle
                                                formControlName="isSubsequent"
                                                [attr.data-testid]="'isSubsequent'">
                                                Ano
                                            </mat-slide-toggle>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

                @if (hasError.invalid) {
                    <app-info-panel>
                        <div class="panel-title">Prosím, vyplňte správně všechny povinné údaje.</div>
                    </app-info-panel>
                }
            </div>
        </div>
    </form>

    <div class="hypo-dialog-footer">
        <button
            (click)="continue()"
            class="btn btn-lg orange income-dialog-button-continue"
            mat-button
            type="button"
            [attr.data-testid]="'income-dialog-button-continue'">
            Pokračovat
        </button>
    </div>
</mat-dialog-content>
